import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { doc, deleteDoc, updateDoc } from "firebase/firestore";
import { db } from "../../firebase";

const CancelBooking = () => {
    const [searchParams] = useSearchParams();
    const [status, setStatus] = useState("loading");

    const bookingId = searchParams.get("id");
    const propertyId = searchParams.get("propertyId");
    const slotId = searchParams.get("slotId");

    useEffect(() => {
        const cancelBooking = async () => {
            if (!bookingId || !propertyId || !slotId) {
                setStatus("invalid");
                return;
            }

            try {
                // 1. Boeking verwijderen
                await deleteDoc(doc(db, "bookings", bookingId));

                // 2. Tijdslot weer beschikbaar maken
                const slotRef = doc(db, "properties", propertyId, "timeslots", slotId);
                await updateDoc(slotRef, {
                    booked: false,
                    bookedBy: null,
                });

                setStatus("success");
            } catch (err) {
                console.error("Annuleren mislukt:", err);
                setStatus("error");
            }
        };

        cancelBooking();
    }, [bookingId, propertyId, slotId]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-100 p-6">
            <div className="bg-white p-6 rounded shadow max-w-md text-center">
                {status === "loading" && <p>Bezig met annuleren...</p>}
                {status === "success" && (
                    <>
                        <h2 className="text-xl font-semibold mb-2 text-[#175151]">Afspraak geannuleerd ✅</h2>
                        <p className="text-gray-600">Je bezichtiging is succesvol geannuleerd.</p>
                    </>
                )}
                {status === "error" && (
                    <>
                        <h2 className="text-xl font-semibold mb-2 text-red-600">Fout bij annuleren</h2>
                        <p className="text-gray-600">Er ging iets mis, probeer het opnieuw of neem contact op met de makelaar.</p>
                    </>
                )}
                {status === "invalid" && (
                    <>
                        <h2 className="text-xl font-semibold mb-2 text-red-600">Ongeldige link</h2>
                        <p className="text-gray-600">Deze annuleringslink is niet geldig.</p>
                    </>
                )}
            </div>
        </div>
    );
};

export default CancelBooking;
